import React from 'react'
import { observer } from 'mobx-react'

import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './stringInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: string | null
}

interface IState {
  value: string | null
}

class DateTimeInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<HTMLInputElement> = React.createRef()

  constructor(props: IProps) {
    super(props)

    const { initialValue } = props
    const value =
      initialValue === undefined || initialValue === null ? null : initialValue

    this.state = {
      value,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () => {
    const { value } = this.state

    if (!value) {
      return value
    }

    try {
      const valueAsDate = new Date(value)
      return valueAsDate.toISOString()
    } catch (e) {
      return value
    }
  }

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { field } = this.props
    const value = e.currentTarget.value

    if (!field.isRequired && value === '') {
      // For optional string fields, it is more common to want to set the value to `null` rather than an empty string, so we're manually doing that here
      this.setState({ value: null })
      return
    }

    this.setState({ value })
  }

  render() {
    const { value } = this.state

    return (
      <input
        data-cy="input--datetime"
        ref={this.input}
        className={styles.input}
        type="text"
        value={value === null || value === undefined ? '' : String(value)}
        placeholder="null"
        onChange={this.handleChange}
      />
    )
  }
}

export default observer(DateTimeInput)
